// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__yunXS","legalContainer":"Footer_legalContainer__TRYJw","socialList":"Footer_socialList__cfeeJ"};